import { PRIORITY_COLORS, PRIORITY_BG } from "../config/constants";

export default function PriorityBadge({ priority }) {
  if (!priority) return <span style={{ color: "var(--text-3)" }}>—</span>;
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      padding: "3px 9px", borderRadius: 999, fontSize: 11, fontWeight: 600,
      background: PRIORITY_BG[priority] || "#f3f4f6",
      color: PRIORITY_COLORS[priority] || "#374151",
    }}>
      <span style={{
        width: 5, height: 5, borderRadius: "50%",
        background: PRIORITY_COLORS[priority] || "#9ca3af",
        display: "inline-block", flexShrink: 0,
      }} />
      {priority}
    </span>
  );
}
